import { useCallback } from 'react';
import { Campaign, Status_Enum as Status } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { useUpdateCampaign } from '@frontend/api-bulk-messaging';
import { useTranslation } from '@frontend/i18n';
import { useAlert } from '@frontend/design-system';
import { useBulkMessageEditorContext } from '../../../bulk-message-editor.context';
import { createCampaignStatusUpdateRequest } from '../../utils/utils';

export const useConvertScheduledCampaignToDraft = (orgId: string, campaign: Campaign) => {
  const { t } = useTranslation('bulk-messaging');
  const { error, info } = useAlert();
  const { currentStatus, setCurrentStatus } = useBulkMessageEditorContext();
  const { mutateAsync: updateCampaign } = useUpdateCampaign(campaign.type);

  return useCallback(async () => {
    if (currentStatus !== Status.SCHEDULED) return;
    try {
      const updatedDraftCampaignRequest = createCampaignStatusUpdateRequest(orgId, Status.DRAFT, campaign);
      await updateCampaign(updatedDraftCampaignRequest);
      setCurrentStatus(Status.DRAFT);
      info(
        t('This campaign is now a draft due to audience changes. Click "Create Campaign" to reschedule the messages.')
      );
    } catch (err) {
      error(
        t(
          'An unexpected error occurred while updating your campaign. Please try again. If the problem persists, contact support.'
        )
      );
      console.error(err);
      return;
    }
  }, [campaign, currentStatus, error, info, orgId, setCurrentStatus, t, updateCampaign]);
};
